import React from 'react';
import Support from '../Components/Support';
import GetQuote from '../Components/GetQuote';
import Map from '../Components/Map';
import ContactInfo from '../Components/ContactInfo';



function Contact() {
    return (
        <>
        <Support/>
        <GetQuote/>
        <Map/>
        <ContactInfo/>
        {/* 
        <!--====== SUPPORT SECTION START ======-->

        <!--====== GET QUOTE SECTION START ======-->

        <!--====== MAP SECTION END ======-->

        <!--====== CONTACT INFO SECTION START ======-->

        */}
        </>
    );
}

export default Contact;
